const teachingGrades = [
  { description: "Pre-K", value: 0x1 },
  { description: "Elementary", value: 0x2 },
  { description: "Jr. High/Middle School", value: 0x10 },
  { description: "High School", value: 0x20 },
  { description: "Post-High", value: 0x40 }
];

export { teachingGrades };
